
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunecab() {



  const cardData =
  {
    keyword: ' Mumbai to Pune Cab Service',
    heading: 'AB Ghule Cabs: Mumbai to Pune Cab Service',
    headingDescription: 'Travel conveniently from Mumbai to Pune with AB Ghule Cabs’ Mumbai to Pune Cab Service. Whether it is for a business trip, a weekend getaway, or a family vacation, we ensure a smooth and comfortable ride. Our fleet of well-maintained vehicles and experienced drivers guarantees a hassle-free journey, offering you the perfect start to your Pune adventure. Pune is approximately 150 km from Mumbai. Pune is approximately 150 km from Mumbai.',

    top: 'Top Places to Visit in Pune with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Shaniwar Wada",
          description: "This historic fortification is one of Pune’s most famous landmarks. Built in the 18th century, it offers a glimpse into the city’s royal past, complete with stunning architecture and a rich history. A must-visit for history buffs and architecture lovers."
        },
        {
          title: "Aga Khan Palace",
          description: "Known for its beautiful architecture and lush gardens, the Aga Khan Palace is also a significant historical site. It was here that Mahatma Gandhi and his associates were imprisoned during the freedom struggle. The palace now houses a museum dedicated to Gandhiji."
        },
        {
          title: "Sinhagad Fort",
          description: "A popular trekking destination located just outside Pune, Sinhagad Fort offers breathtaking views of the surrounding hills and valleys. It’s the perfect spot for a historical exploration and scenic hike."
        },
        {
          title: "Pune Okayama Friendship Garden",
          description: "Inspired by the Japanese aesthetic, this tranquil garden is a peaceful escape from the hustle and bustle of the city. Ideal for leisurely strolls, picnics, and spending time in nature, it’s a serene spot for relaxation."
        },
        {
          title: "Dagdusheth Halwai Ganapati Temple",
          description: "One of the most famous Ganesh temples in India, the Dagdusheth Halwai Ganapati Temple is a symbol of devotion and spirituality. The temple is known for its grand celebrations, especially during the Ganesh Chaturthi festival."
        },
        {
          title: "Fergusson College",
          description: "Established in 1885, Fergusson College is an iconic educational institution in Pune. Known for its beautiful campus, this college is an architectural marvel and offers a peaceful ambiance for a walk or a quiet afternoon."
        },
        {
          title: "Pataleshwar Cave Temple",
          description: "A rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple offers a glimpse into ancient Indian rock architecture. The temple is situated in the heart of Pune and is a peaceful site for spiritual reflection."
        },
        {
          title: "Rajiv Gandhi Zoological Park",
          description: "Located in Katraj, this zoological park is home to a variety of animals and birds. It’s a great place for families to enjoy and learn about wildlife conservation while exploring the park’s lush green surroundings."
        },
        {
          title: "Nehru Memorial Museum",
          description: "Dedicated to the life and legacy of Jawaharlal Nehru, India’s first Prime Minister, this museum houses a variety of photographs, letters, and artifacts that highlight his contributions to the nation’s development."
        },
        {
          title: "Mulshi Dam",
          description: "Situated just outside Pune, Mulshi Dam is a scenic spot known for its natural beauty. The lush greenery and peaceful surroundings make it a perfect location for picnics, photography, and relaxation, especially during the monsoon season when the landscape is at its best."
        }
      ],


  services: [
  {
    "name": "Mumbai Airport to Pune Cab",
    description: "Looking for a taxi from Mumbai Airport to Pune? AB Ghule Cabs offers comfortable, reliable, and affordable cab services for a smooth journey. Whether you're arriving at Terminal 1 or Terminal 2, our professional drivers are well-versed in handling airport pick-ups, ensuring you are greeted on time and travel to Pune in comfort and style. Our cabs are well-maintained and equipped with modern amenities to make your journey pleasant and hassle-free."
  },
  {
    "name": "Mumbai to Pune Taxi",
    description: "Book a taxi from Mumbai to Pune with AB Ghule Cabs for a comfortable and efficient travel experience. We offer a fleet of well-maintained vehicles suited for both business and leisure trips. Our experienced drivers ensure safety and convenience, adhering to the best traffic routes to minimize delays. Whether you're traveling for a meeting or a vacation, we provide timely service, ensuring you reach your destination relaxed and on time."
  },
  {
    "name": "Mumbai to Pune Cab Price",
    description: "Check the Mumbai to Pune cab price with AB Ghule Cabs. Our transparent and competitive pricing ensures that you get great value for your journey. No hidden charges – only clear, upfront pricing for your convenience. We take pride in offering the best prices while maintaining a high level of service. Our fare structure is designed to suit both short and long-distance travelers, making it affordable for everyone."
  },
  {
    "name": "Mumbai Pune Taxi Fare",
    description: "Traveling from Mumbai to Pune? AB Ghule Cabs offers affordable and competitive Mumbai Pune taxi fares without any hidden costs. We believe in transparent pricing, so you know exactly what you’re paying for. Our professional drivers ensure a smooth, safe, and enjoyable ride. Whether you're on a budget or prefer a premium experience, we have options to suit all your needs while maintaining comfort and reliability."
  },
  {
    "name": "Mumbai to Pune Cab Service",
    description: "Book your Mumbai to Pune cab service with AB Ghule Cabs for a safe and timely ride. We provide professional drivers who are familiar with the most efficient routes, ensuring you reach Pune without delays. Our well-maintained fleet includes cars of all sizes and comfort levels, from economical options to luxurious vehicles. Whether you need a one-time ride or a regular service, we ensure a pleasant and reliable journey every time."
  },
  {
    "name": "Mumbai to Pune Taxi Price",
    description: "For an affordable and reliable taxi ride from Mumbai to Pune, AB Ghule Cabs offers the best pricing with no hidden charges. Our fleet is equipped to ensure that your journey is comfortable, safe, and relaxing. The pricing is designed to suit various needs, whether you're traveling solo or with family. We pride ourselves on offering transparent and competitive pricing without compromising on quality or service."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Fare",
    description: "Need a taxi from Mumbai Airport to Pune? AB Ghule Cabs offers affordable and transparent taxi fares for airport transfers. We ensure you get to your destination on time with comfort and style. Whether you're arriving for a business trip or a vacation, our professional drivers are experienced in handling airport pick-ups and transfers to Pune, making your experience stress-free and efficient. Our fleet includes modern, well-maintained vehicles designed for a smooth ride."
  },
  {
    "name": "Mumbai Pune Car Rental",
    description: "Looking for a car rental service for your journey from Mumbai to Pune? AB Ghule Cabs offers flexible car rental options tailored to your preferences. Choose from a range of vehicles, including compact cars, sedans, SUVs, and luxury cars, based on your needs and budget. Our professional drivers ensure a smooth, safe, and comfortable ride, making your journey from Mumbai to Pune enjoyable and hassle-free."
  },
  {
    "name": "Mumbai Pune Cab One Way",
    description: "AB Ghule Cabs offers one-way cab services from Mumbai to Pune, providing convenience and comfort for travelers who prefer a single-trip journey. Whether you're heading to Pune for a short stay or a specific event, our one-way taxi services are designed to be cost-effective and efficient. You won’t have to worry about return trips, as we ensure you get to your destination promptly with no unnecessary delays."
  },
  {
    "name": "Mumbai to Pune Cab from Airport",
    description: "Book a taxi from Mumbai Airport to Pune with AB Ghule Cabs for a convenient and timely transfer. We offer a seamless pick-up service right from the airport to your destination in Pune. Our professional drivers are punctual, courteous, and knowledgeable about the quickest routes, ensuring a smooth and pleasant journey. With competitive pricing and high-quality service, you can trust us to make your airport transfer easy and stress-free."
  },
  {
    "name": "Mumbai Airport Terminal 2 to Pune Cab",
    description: "If you're arriving at Mumbai Airport Terminal 2, AB Ghule Cabs provides hassle-free taxi services to Pune. Our drivers are experienced in handling airport pick-ups from Terminal 2 and will ensure a prompt, smooth ride to your destination. With competitive pricing and well-maintained vehicles, we guarantee a comfortable ride that fits your travel needs. Whether you're traveling for business or leisure, expect reliable and professional service."
  },
  {
    "name": "Mumbai Airport to Pune Cab Fare",
    description: "Looking for the best Mumbai Airport to Pune cab fare? AB Ghule Cabs offers competitive prices for airport transfers. Our pricing structure is designed to be clear and transparent, with no hidden charges. We ensure you travel comfortably and reach your destination on time. Our professional drivers are skilled in navigating the best routes, and we provide high-quality vehicles to ensure your ride is both affordable and pleasant."
  },
  {
    "name": "Dadar to Pune Taxi Charges",
    description: "AB Ghule Cabs offers affordable and transparent taxi charges for your ride from Dadar to Pune. Our pricing is designed to be competitive, ensuring that you get the best value for your money. Our experienced drivers are familiar with the most efficient routes, ensuring that you reach Pune comfortably and on time. We take pride in our reliability and excellent customer service, making us the best choice for your travel needs."
  },
  {
    "name": "Best Cab Service Mumbai to Pune",
    description: "For the best cab service from Mumbai to Pune, choose AB Ghule Cabs. We offer the most reliable, comfortable, and punctual services at competitive prices. Our fleet of vehicles is well-maintained and diverse, catering to different travel preferences and budgets. With professional drivers who prioritize your safety and comfort, we ensure a smooth journey whether you're traveling for work, leisure, or special events."
  },
  {
    "name": "Cab for Mumbai to Pune",
    description: "Looking for a cab from Mumbai to Pune? AB Ghule Cabs offers convenient, affordable, and reliable cab services for your journey. Our fleet of well-maintained vehicles and experienced drivers ensure a pleasant, safe, and comfortable trip. Whether you're traveling solo or with family or friends, we provide a range of vehicle options to suit your travel needs. We ensure that your trip is smooth, timely, and hassle-free."
  },
  {
    "name": "Cab Service Mumbai to Pune",
    description: "AB Ghule Cabs offers top-quality cab services from Mumbai to Pune. Whether you're traveling for business, a weekend getaway, or a special event, we ensure a comfortable and safe journey. Our fleet includes a variety of vehicles, and our professional drivers ensure you travel with ease. We guarantee timely pickups and drop-offs, with no hidden charges, ensuring that your ride is as efficient and enjoyable as possible."
  },
  {
    "name": "Mumbai to Pune Return Cab Fare",
    description: "AB Ghule Cabs provides affordable return cab fares for your trip from Mumbai to Pune. Whether you're planning a round-trip for business or leisure, we ensure you get the best price and service for both legs of your journey. Our fleet is equipped to handle both one-way and return trips with ease, and our professional drivers ensure a smooth, punctual experience every time. We offer transparent pricing, so you know exactly what to expect."
  },
  {
    "name": "Mumbai Pune Cab Fare",
    description: "Our Mumbai Pune cab fares are designed to offer the best value for money. AB Ghule Cabs ensures transparent pricing with no hidden charges. Whether you need a one-way trip, return journey, or even an extended stay in Pune, we provide affordable pricing without compromising on comfort or quality. Our professional drivers will ensure you get to your destination safely, comfortably, and on time."
  },
  {
    "name": "Mumbai to Pune Taxi Charges",
    description: "For a clear, competitive pricing structure, AB Ghule Cabs offers affordable taxi charges for your journey from Mumbai to Pune. Our service ensures comfort, timeliness, and value for money. With experienced drivers familiar with the best routes, we guarantee a smooth and hassle-free journey. No hidden charges – only upfront pricing to ensure transparency throughout your trip."
  },
  {
    "name": "Cab Booking Mumbai to Pune",
    description: "Book your cab from Mumbai to Pune with AB Ghule Cabs. We offer easy online booking options and a wide selection of vehicles to suit your travel needs. From budget-friendly cars to premium options, we provide a variety of choices to ensure your journey is both affordable and comfortable. Our professional drivers ensure you have a safe and pleasant ride, making the booking process as simple and hassle-free as possible."
  },
  {
    "name": "Mumbai to Pune Cab Contact Number",
    description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai to Pune Cab service. We ensure a smooth and enjoyable ride for all our customers, with well-maintained vehicles and experienced drivers ready to make your journey hassle-free. Whether you need a ride to Pune or from the airport, we are here to help you every step of the way."
  }
  ],

  tableData: [
    ["- Mumbai airport to Pune cab", "- Mumbai to Pune taxi"],
    ["- Mumbai to Pune cab price", "- Mumbai Pune taxi fare"],
    ["- Mumbai to Pune cab service", "- Mumbai to Pune taxi price"],
    ["- Mumbai airport to Pune taxi fare", "- Mumbai Pune car rental"],
    ["- Mumbai Pune cab one way", "- Mumbai to Pune cab from airport"],
    ["- Mumbai airport terminal 2 to Pune cab", "- Mumbai airport to Pune cab fare"],
    ["- Dadar to Pune taxi charges", "- Best cab service Mumbai to Pune"],
    ["- Cab for Mumbai to Pune", "- Cab service Mumbai to Pune"],
    ["- Mumbai to Pune return cab fare", "- Mumbai Pune cab fare"],
    ["- Mumbai to Pune taxi charges", "- Cab booking Mumbai to Pune"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we specialize in providing reliable and professional taxi services for your journey from Mumbai to Pune. Our drivers are experienced, well-trained, and committed to delivering a smooth and comfortable travel experience."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether it's an early morning trip or a late-night journey, AB Ghule Cabs is available 24/7 to serve your Mumbai to Pune travel needs. Our customer service team is always ready to assist with booking a cab at any time."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive and transparent pricing with no hidden charges for your Mumbai to Pune taxi ride. We ensure that you get value for your money without compromising on quality and comfort."
    },
    {
      WhyChooseheading: "Comfortable and Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are regularly cleaned, maintained, and thoroughly inspected to provide you with a comfortable and safe ride. Choose from a variety of vehicles, including sedans and SUVs, for your journey."
    },
    {
      WhyChooseheading: "Experienced and Safe Drivers",
      WhyChoosedescription: "Your safety is our priority. All our drivers are experienced, professional, and background-checked, ensuring a safe and secure ride from Mumbai to Pune. They are well-versed in the best routes to avoid traffic and provide a smooth ride."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your Mumbai to Pune taxi is simple. You can make a reservation online via our website or mobile app, or you can call our customer service team for immediate assistance."
    },
    {
      WhyChooseheading: "Customer Satisfaction Guarantee",
      WhyChoosedescription: "We are committed to ensuring your satisfaction, as reflected in our many positive customer reviews. We go the extra mile to ensure a pleasant and hassle-free travel experience."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai to Pune cab with AB Ghule Cabs?',
      answer: 'You can book your Mumbai to Pune cab online through our website or mobile app, or by calling our customer service helpline. We make the booking process quick and easy.',
    },
    {
      id: 'FAQ2',
      question: 'How long does the journey from Mumbai to Pune take?',
      answer: 'The journey from Mumbai to Pune typically takes around 3 to 4 hours, depending on traffic conditions and the route taken.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for the Mumbai to Pune cab service?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, catering to your comfort and travel needs.',
    },
    {
      id: 'FAQ4',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all our drivers are experienced, professional, and background-checked to ensure your safety and comfort during the trip.',
    },
    {
      id: 'FAQ5',
      question: 'What is the cost of a Mumbai to Pune taxi ride?',
      answer: 'The cost of your taxi ride depends on the vehicle type, route, and duration of the journey. You can get an accurate quote through our website or by calling our customer service.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer round-trip services for Mumbai to Pune?',
      answer: 'Yes, we offer both one-way and round-trip services for Mumbai to Pune. You can choose the option that suits your travel plans.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for my Mumbai to Pune cab ride?',
      answer: 'You can pay for your ride via cash, credit/debit card, or online payment through our mobile app or website, offering you flexibility and convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking for the Mumbai to Pune cab?',
      answer: 'Yes, you can easily modify or cancel your booking through our website or app. If you need assistance, our customer service team will be happy to help.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any additional charges for tolls or detours during the journey?',
      answer: 'There may be additional charges for tolls or detours, but we ensure transparent pricing. Any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ10',
      question: 'Why should I choose AB Ghule Cabs for my Mumbai to Pune taxi ride?',
      answer: 'AB Ghule Cabs stands out for its reliable service, experienced drivers, well-maintained fleet, competitive pricing, and excellent customer support. We focus on providing a safe, comfortable, and punctual journey.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Amit Desai",
      feedback: "I booked a cab with AB Ghule Cabs for my Mumbai to Pune trip, and I had a fantastic experience. The car was clean, the driver was friendly and professional, and we reached Pune on time. Highly recommend their services for anyone traveling between Mumbai and Pune!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Priya Shah",
      feedback: "AB Ghule Cabs made my journey from Mumbai to Pune comfortable and stress-free. The driver knew the best routes to avoid traffic, and the car was in excellent condition. I will definitely choose them again for future trips!",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Pune Taxi | Mumbai to Pune Cab Service</title>
  <meta name="description" content="Affordable Mumbai to Pune taxi service. Book one-way or round-trip cabs, including airport transfers and custom car rentals. Get the best fares for Mumbai to Pune taxi, airport taxi, and more." />
  <meta name="keywords" content="Mumbai Airport to Pune Cab, Mumbai to Pune Taxi, Mumbai to Pune Cab Price, Mumbai Pune Taxi Fare, Mumbai to Pune Cab Service, Mumbai to Pune Taxi Price, Mumbai Airport to Pune Taxi Fare, Mumbai Pune Car Rental, Mumbai Pune Cab One Way, Mumbai to Pune Cab from Airport, Mumbai Airport Terminal 2 to Pune Cab, Mumbai Airport to Pune Cab Fare, Dadar to Pune Taxi Charges, Best Cab Service Mumbai to Pune, Cab for Mumbai to Pune, Cab Service Mumbai to Pune, Mumbai to Pune Return Cab Fare, Mumbai Pune Cab Fare, Mumbai to Pune Taxi Charges, Cab Booking Mumbai to Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Pune Taxi | Mumbai to Pune Cab Service" />
  <meta property="og:description" content="Affordable Mumbai to Pune taxi service. Book one-way or round-trip cabs, including airport transfers and custom car rentals. Get the best fares for Mumbai to Pune taxi, airport taxi, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-pune-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-to-pune-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Affordable Mumbai to Pune taxi service. Book one-way or round-trip cabs, including airport transfers and custom car rentals. Get the best fares for Mumbai to Pune taxi, airport taxi, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-to-pune-taxi",
        "logo": "https://abghulecabs.com/images/mumbai-pune-taxi.jpg",
        "image": "https://abghulecabs.com/images/mumbai-pune-taxi.jpg",
        "priceRange": "₹1500 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-to-pune-taxi",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "2000"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi Shankar"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Excellent service! The cab was clean, and the driver was very professional. The trip from Mumbai to Pune was smooth and comfortable."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya Deshmukh"
            },
            "datePublished": "2024-10-20",
            "reviewBody": "Reliable and affordable taxi service for my Mumbai to Pune journey. Will definitely use this service again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai and Pune",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-to-pune-taxi"
        },
        "keywords": "Mumbai Airport to Pune Cab, Mumbai to Pune Taxi, Mumbai to Pune Cab Price, Mumbai Pune Taxi Fare, Mumbai to Pune Cab Service, Mumbai to Pune Taxi Price, Mumbai Airport to Pune Taxi Fare, Mumbai Pune Car Rental, Mumbai Pune Cab One Way, Mumbai to Pune Cab from Airport, Mumbai Airport Terminal 2 to Pune Cab, Mumbai Airport to Pune Cab Fare, Dadar to Pune Taxi Charges, Best Cab Service Mumbai to Pune, Cab for Mumbai to Pune, Cab Service Mumbai to Pune, Mumbai to Pune Return Cab Fare, Mumbai Pune Cab Fare, Mumbai to Pune Taxi Charges, Cab Booking Mumbai to Pune"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/5.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitopunecab;